import { Card, Tabs, Typography } from "antd";
import { UserManagement, SalesConfigurationSetup, LookupSetup } from "admin/components";
import { SubcontractorSetup } from "subcontractors/components";
import { GeneralSettings } from "./GeneralSettings";
import { useBoundStore } from "store";
import { SideNavPageLayout } from "shared/components";
import "./OrganizationSettings.scss";

export const OrganizationSettings = () => {
  const { currentOrganization } = useBoundStore();

  return (
      <Card className="organization-settings-container">
        <Typography.Title level={1}>
          {currentOrganization?.name} Settings
        </Typography.Title>
        <Tabs
          defaultActiveKey="general"
          items={[
            {
              key: "general",
              label: "General",
              children: <GeneralSettings />,
            },
            {
              key: "users",
              label: "User Management",
              children: <UserManagement />,
            },
            {
              key: "sales",
              label: "Sales Configurations",
              children: <SalesConfigurationSetup />,
            },
            {
              key: "subcontractors",
              label: "Subcontractors",
              children: <SubcontractorSetup />,
            },
            {
              key: "lookups",
              label: "Lookup Values",
              children: <LookupSetup />,
            },
          ]}
        />
      </Card>
  );
};
